import { render, staticRenderFns } from "./TechnologicalInnovationApproval.vue?vue&type=template&id=6fb7d624&scoped=true"
import script from "./TechnologicalInnovationApproval.vue?vue&type=script&lang=js"
export * from "./TechnologicalInnovationApproval.vue?vue&type=script&lang=js"
import style0 from "./TechnologicalInnovationApproval.vue?vue&type=style&index=0&id=6fb7d624&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb7d624",
  null
  
)

export default component.exports